import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { useRoot } from '../useRoot';
import { VideoPlayerSettingsModel } from './VideoPlayerSettingsModel';
import { VideoPlayerMemoryModel } from './VideoPlayerMemoryModel';

export class App extends Model({
  launchDate: types.maybeNull(types.Date),
  wasNotificationPermissionEverRequested: false,
  authCount: 0,
  tutorialsViewCount: 0,
  tutorialsViewTime: 0,
  videoPlayerSettings: types.optional(VideoPlayerSettingsModel, {}),
  videoPlayerMemory: types.optional(VideoPlayerMemoryModel, {}),
}) {
  get isNeedToSuggestInvite() {
    return this.authCount === 1 || this.authCount === 4;
  }

  get isEveryFiveTutorialsViewed() {
    return this.tutorialsViewCount % 5 === 0;
  }

  get hasEverLaunched() {
    return !!this.launchDate;
  }

  updateNotificationPermissionEverRequested() {
    this.wasNotificationPermissionEverRequested = true;
  }

  updateLaunchDate() {
    this.launchDate = new Date();
  }

  incrementAuthCount() {
    this.authCount++;
  }

  incrementViewedTutorials() {
    this.tutorialsViewCount++;
  }
}

export const AppModel = model(App);

export function useAppModel() {
  const root = useRoot();

  return root.app;
}
